var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { AlertBodyLeftWrapper, AlertsBodyMediumText, AlertsBodySmallText } from './subcomponents';
import InputField from '../../atoms/InputField';
import { AlertIDType } from '../../../const/alertsConfig';
var AlertBodyLeft = function (_a) {
    var alertId = _a.alertId, alertFormData = _a.alertFormData, currentAlertData = _a.currentAlertData, inputRef = _a.inputRef;
    var t = useTranslation().t;
    var isSetpayOrApprovedTransaction = alertId === AlertIDType.APPROVED_TRANSACTIONS ||
        alertId === AlertIDType.SYF_PAY_LATER;
    var isApprovedTransactionAlert = alertId === AlertIDType.APPROVED_TRANSACTIONS;
    var INPUT_LABEL = alertId.toLowerCase();
    return (_jsxs(AlertBodyLeftWrapper, __assign({ "data-test": "AlertBodyLeftWrapper" }, { children: [_jsx(AlertsBodySmallText, __assign({ "data-test": "AlertsBodySmallText" }, { children: isSetpayOrApprovedTransaction
                    ? t('alertsBody.leftDescriptionSyfPayLaterOrApprovedTransactions')
                    : t('alertsBody.leftDescription') })), _jsx(AlertsBodyMediumText, __assign({ "data-test": "AlertsBodyMediumText" }, { children: !isApprovedTransactionAlert && t("inputLabels.".concat(INPUT_LABEL)) })), Object.keys(alertFormData.attributes).map(function (attKey) {
                return (_jsx("div", { children: _jsx(InputField, { alertId: alertId, attributeKey: attKey, alertFormData: alertFormData, currentAlertData: currentAlertData, inputRef: inputRef }) }, attKey));
            })] })));
};
export default AlertBodyLeft;
